// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

// 3rd party imports
import { DxScrollViewComponent } from 'devextreme-angular';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-welcome-message',
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss'],
  standalone: false
})
export class WelcomeMessageComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true })
  scrollView: DxScrollViewComponent;

  isSmallScreen: boolean = false;

  toHideComponentFlag: boolean = false;

  scrollByContent: boolean = true;
  scrollByThumb: boolean = true;
  scrollbarMode: string = 'onHover';

  constructor(
    private router: Router,
    private screenService: ScreenService
  ) {
    RxjsUtils.subscribeToRouterEvents(this.router, (event: Event): void => {
      if (event instanceof NavigationEnd) {
        this.toHideComponentFlag = this.router.isActive('/user/signup', true);
      }
    });
  }

  ngOnInit() {
    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () => {
      this.updateScreenSize();
    });
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }
}
